import { Box, Button, ButtonBase, Popper, useTheme } from "@mui/material";
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { tokens } from "../../../theme";
import PopoverModal from "../Modal/PopoverModal";
import { useTranslation } from "react-i18next";
import TextInput from "../inputs/TextInput";
import cx from "classnames";

import { ReactComponent as TableEmpty } from '../../../styles/svg/tableempty.svg'
import Text from "../text/Text";
import Subheading from "../text/Subheading";
import { useInView } from "react-intersection-observer";

export const DropdownBase = (props) => {
    if(!props.children) throw Error("No child element set for Dropdownbase");
    
    const [anchorEl, setAnchorEl] = useState(null);
    const popoverOpen = Boolean(anchorEl);
    const popoverId = popoverOpen ? 'popover' : undefined;

    const [selected, setSelected] = useState(props.multiple ? [] : props.selected ?? -1); //inner for displayname

    // console.log(props.options,props.options);

    useEffect(() => {
        if (props.toggleDragAndDrop) {
            props.toggleDragAndDrop(!popoverOpen);
        }
    }, [popoverOpen, props.toggleDragAndDrop]);
    
    const handlePopoverClick = (event) => {
        if(props.disabled) {
            return;
        }
        if(props.stopPropagation){
            event.stopPropagation();
        }
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        if(props.selectOnClose){
            props.selectOnClose(selected)
        }
    };

    const handleChange = (selected) => {
        setSelected(selected);
        if(!props.selectOnClose){
            props.onChange(selected);
            if(props.closeOnSelection) {
                setAnchorEl(null);
            }
            if(props.resetOnSelection){
                setSelected(-1);
            }
        }
    }

    useEffect(() => {
        if(typeof props.selected !== "undefined"){
            setSelected(props.selected)
        }
    },[props.selected])


    const excludedProps = ['displayName','anchorOrigin','transformOrigin','noSelection','closeOnSelection','toggleDragAndDrop','searchOptions','valueKey','disallowDeselection','useTranslation', 'describedBy','stopPropagation','lazyMount'];

    const filteredProps = useMemo(() => Object.keys(props).reduce((acc, key) => {
        if (!excludedProps.includes(key)) {
            acc[key] = props[key];
        }
        return acc;
    }, {}),[props]);


    return (
        <>
            {React.cloneElement(props.children, 
                {
                    ...filteredProps,
                    options: props.options, 
                    selected: selected, 
                    onClick:handlePopoverClick
                }
            )}

            {/* <ShDropdown */}
            {/* Opt-in lazy mount: skip the (expensive) ShDropdown subtree until the
                dropdown is first opened. Closed-and-never-opened dropdowns cost nothing. */}
            {(!props.lazyMount || popoverOpen) && (
            <ShDropdown
                allowSelectAll={props.allowSelectAll}
                shComponent={props.shComponent ?? null}
                anchorOrigin={props.anchorOrigin}
                transformOrigin={props.transformOrigin}
                id={popoverId}
                open={popoverOpen}
                anchorEl={anchorEl}
                onClose={handleClose}
                onChange={handleChange}
                useTranslation={props.useTranslation}
                displayName={props.displayName ?? "name"}
                optionGroupKey={props.optionGroupKey ?? null}
                multiple={props.multiple ?? false}
                options={props.options}
                selected={selected}
                maxHeight={props.maxHeight}
                valueKey={props.valueKey ?? null}
                showNullAsSelected={props.showNullAsSelected ?? false}
                searchOptions={props.searchOptions}
                styles={props.styles}
                defaultStyling={props.defaultStyling ?? false}
                disallowDeselection={props.disallowDeselection ?? null}
                sx={props.sx}
                noPropagationOnSelect={props.noPropagationOnSelect ?? false}
                modalPropagation={props.modalPropagation ?? false}
                filterDropdownOptions={props.filterDropdownOptions ?? null}
                filterDropdownOnSelect={props.filterDropdownOnSelect ?? null}
                unSelectable={props.unSelectable ?? false}
                // enableSearch={props.enableSearch}
            />
            )}
        </>
    );
}

export const DropdownBaseV2 = (props) => {
    if(!props.children) throw Error("No child element set for Dropdownbase");
    
    const [anchorEl, setAnchorEl] = useState(null);
    const popoverOpen = Boolean(anchorEl);
    const popoverId = popoverOpen ? 'popover' : undefined;

    const [selected, setSelected] = useState(props.multiple ? [] : props.selected ?? -1); //inner for displayname

    // console.log(props.options,props.options);

    useEffect(() => {
        if (props.toggleDragAndDrop) {
            props.toggleDragAndDrop(!popoverOpen);
        }
    }, [popoverOpen, props.toggleDragAndDrop]);
    
    const handlePopoverClick = (event) => {
        if(props.disabled) {
            return;
        }
        if(props.stopPropagation){
            event.stopPropagation();
        }
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        if(props.selectOnClose){
            props.selectOnClose(selected)
        }
    };

    const handleChange = (selected) => {
        setSelected(selected);
        if(!props.selectOnClose){
            props.onChange(selected);
            if(props.closeOnSelection) {
                setAnchorEl(null);
            }
            if(props.resetOnSelection){
                setSelected(-1);
            }
        }
    }

    useEffect(() => {
        if(typeof props.selected !== "undefined"){
            setSelected(props.selected)
        }
    },[props.selected])


    const excludedProps = ['displayName','anchorOrigin','transformOrigin','noSelection','closeOnSelection','toggleDragAndDrop','searchOptions','valueKey','disallowDeselection','useTranslation', 'describedBy','stopPropagation','lazyMount'];

    const filteredProps = useMemo(() => Object.keys(props).reduce((acc, key) => {
        if (!excludedProps.includes(key)) {
            acc[key] = props[key];
        }
        return acc;
    }, {}),[props]);


    return (
        <>
        
            {props.children(
                {
                    ...filteredProps,
                    options: props.options, 
                    selected: selected, 
                    onClick:handlePopoverClick
                })
            }

            {/* <ShDropdown */}
            {/* Opt-in lazy mount: skip the (expensive) ShDropdown subtree until the
                dropdown is first opened. Closed-and-never-opened dropdowns cost nothing. */}
            {(!props.lazyMount || popoverOpen) && (
            <ShDropdown
                allowSelectAll={props.allowSelectAll}
                shComponent={props.shComponent ?? null}
                anchorOrigin={props.anchorOrigin}
                transformOrigin={props.transformOrigin}
                id={popoverId}
                open={popoverOpen}
                anchorEl={anchorEl}
                onClose={handleClose}
                onChange={handleChange}
                useTranslation={props.useTranslation}
                displayName={props.displayName ?? "name"}
                multiple={props.multiple ?? false}
                options={props.options}
                selected={selected}
                maxHeight={props.maxHeight}
                valueKey={props.valueKey ?? null}
                searchOptions={props.searchOptions}
                styles={props.styles}
                defaultStyling={props.defaultStyling ?? false}
                disallowDeselection={props.disallowDeselection ?? null}
                sx={props.sx}
                noPropagationOnSelect={props.noPropagationOnSelect ?? false}
                modalPropagation={props.modalPropagation ?? false}
                filterDropdownOptions={props.filterDropdownOptions ?? null}
                filterDropdownOnSelect={props.filterDropdownOnSelect ?? null}
                unSelectable={props.unSelectable ?? false}
                // enableSearch={props.enableSearch}
            />
            )}
        </>
    );
}


const ShDropdown = (props) => {
    // if (props.disallowDeselection && props.multiple) {
    //     throw Error("Disallowdeselection and multiple selection cannot go together");
    // }

    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const multiple = props.multiple ?? false;
    const [searchValue, setSearchValue] = useState('');
    const [filteredOptions, setFilteredOptions] = useState([]);
    const workerRef = useRef(null);
    const debounceTimeoutRef = useRef(null);
    
    const [debouncedSearchValue, setDebouncedSearchValue] = useState(searchValue);
    
    // Pagination state
    const [displayCount, setDisplayCount] = useState(50);

    // Intersection observer setup. Use the scrollable container as root so Edge
    // reliably fires the callback; threshold 1.0 on a sub-pixel sentinel is flaky there.
    const [scrollEl, setScrollEl] = useState(null);
    const { ref, inView } = useInView({
        root: scrollEl,
        threshold: 0,
        rootMargin: "100px 0px",
    });

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const getOptionValue = (option, index) => {
        // If valueKey is provided and the option is an object, use it to get the value.
        // Otherwise, default to using the index as the value.
        // Guard against null: typeof null === "object", so an unguarded lookup on a
        // deselected value (onChange(null)) would throw "reading '<valueKey>'".
        return props.valueKey && option && typeof option === "object" ? option[props.valueKey] : props.options?.indexOf(option);
    };


    const switchSelected = (index) => {
        const selectedValue = getOptionValue(filteredOptions[index], index);
        const isValueSelected = props.valueKey ? selectedValue === props.selected : index === props.selected;

        if(props.searchOptions?.enabled) {
            setSearchValue("");
            filterOptions("");
            props.searchOptions?.onSearch?.("");
        }

        if(!multiple) {
            if(isValueSelected && !props.disallowDeselection) {
                props.onChange(props.valueKey ? null : -1);
            } else {
                props.onChange(selectedValue);
            }
        } else {
            if (props.selected.includes(selectedValue)) {
                const newSelected = props.selected.filter(val => val !== selectedValue);
                props.onChange(newSelected);
            } else {
                const newSelected = [...props.selected, selectedValue];
                props.onChange(newSelected);
            }
        }
    };

    const isSelected = (index) => {
        const selectedValue = getOptionValue(filteredOptions[index], index);
        // With showNullAsSelected a null selection is a real value, not the absence
        // of one: resolving it through getOptionValue would yield indexOf(null) and
        // never match the option whose value is null.
        const currentValue = (props.showNullAsSelected && props.selected === null)
            ? null
            : (typeof props.selected === 'number' ? props.selected : getOptionValue(props.selected));

        if(!multiple) {
            return selectedValue === currentValue;
        }

        return props.selected.includes(selectedValue);
    };

    const getBackground = (index) => {
        if(isSelected(index)) {
            return theme.palette.mode === "dark" ?
                colors.blue[100] : colors.primary[100];
        }
        return theme.palette.mode === "dark" ? colors.grey[300] : "#fff";
    }
    const getColor = (index) => {
        if(isSelected(index)) {
            return theme.palette.mode === "dark" ?
                colors.blue[400] : colors.primary[400];
        }
        return colors.txt.primary;
    }
    // Handle search input change with debounce
    const handleSearchChange = (event) => {
        let value = event.target.value;
        // if(event.code === "Space") {
        //     value += " ";
        // }
        setSearchValue(value);

        // Clear previous debounce timeout
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        // Set a new debounce timeout
        debounceTimeoutRef.current = setTimeout(() => {
            if (props.searchOptions?.onSearch) {
                // Server-side search: the parent refreshes props.options with the
                // results; the options effect below resets the visible list.
                props.searchOptions.onSearch(value);
            } else {
                filterOptions(value); // Apply filtering after debounce delay
            }
            setDisplayCount(50); // Reset display count on new search
        }, 300); // 300ms debounce delay (adjust as needed)
    };

    // Filtering logic
    const filterOptions = (value) => {
        if (!value) {
            setFilteredOptions(props.options);
            return;
        }

        const lowerCasedSearchValue = value.toLowerCase();
        
        const filtered = props.options.filter((option) => {
            const { searchables = [] } = props.searchOptions || {};

            // Always check the main display field
            const optionValue = option && option[props.displayName] ? option[props.displayName] : option;

            if (optionValue?.toString().toLowerCase().includes(lowerCasedSearchValue)) {
                return true;
            }
            

            // Check additional searchable fields
            for (const field of searchables) {
                const fieldValue = option[field];

                if (fieldValue !== undefined && fieldValue !== null) {
                    // If fieldValue is an array (like barcodes)
                    if (Array.isArray(fieldValue)) {
                        if (fieldValue.some(val => val?.toString().toLowerCase().includes(lowerCasedSearchValue))) {
                            return true;
                        }
                    } else if (fieldValue.toString().toLowerCase().includes(lowerCasedSearchValue)) {
                        return true;
                    }
                }
            }

            return false; // No match
        });

        setFilteredOptions(filtered);
    };

    // Load more on inView
    useEffect(() => {
        if (inView && filteredOptions?.length) {
            setDisplayCount((prev) => Math.min(prev + 50, filteredOptions.length));
        }
    }, [inView, filteredOptions]);

    // Slice the filtered options based on displayCount
    const visibleOptions = useMemo(() => {
        return Array.isArray(filteredOptions)
            ? filteredOptions.slice(0, displayCount)
            : [];
    }, [filteredOptions, displayCount]);

    // Reset filtered options when props.options changes
    useEffect(() => {
        setFilteredOptions(props.options);
    }, [props.options]);



    // const handleSearchChange = (event) => {
    //     setSearchValue(event.target.value);
    // };


    // const filteredOptions = props.options?.filter((option) => {
    //     const optionValue = typeof option === "object" ? option[props.displayName] : option;
    //     return optionValue.toString().toLowerCase().includes(debouncedSearchValue.toLowerCase());
    // });
    // const filteredOptions = useMemo(() => {
    //     return props.options?.filter((option) => {
    //         const optionValue = typeof option === "object" ? option[props.displayName] : option;
    //         return optionValue.toString().toLowerCase().includes(debouncedSearchValue.toLowerCase());
    //     });
    // }, [props.options, debouncedSearchValue]);

    // Define the props you want to exclude
    const excludedProps = ['displayName','noSelection','closeOnSelection','toggleDragAndDrop','searchOptions','valueKey','disallowDeselection','useTranslation', 'describedBy'];


    // Programmatically filter out the props
    const filteredProps = useMemo(() => Object.keys(props).reduce((acc, key) => {
        if (!excludedProps.includes(key)) {
            // console.log("key",key)
            acc[key] = props[key];
        }
        return acc;
    }, {}),[props]);

    const handleSelect = useCallback((event,index) => {
        if(props.unSelectable) return;
        if(props.noPropagationOnSelect){
            event.stopPropagation();
        }
        switchSelected(index);
    }, [switchSelected, props.unSelectable, props.noPropagationOnSelect]); // Include any dependencies if necessary

    const searchCompletion = (event) => {
        if(event.code === "Enter") {
            if(props.valueKey) {
                for(var i = 0; i < props.options.length; i++) {
                    if(props.options[i][props.displayName] === (event.target.value)){
                        props.onChange(props.options[i][props.valueKey]);
                        setSearchValue("");
                    }
                }
            } else {
                props.onChange(props.options.indexOf[event.target.value])
                setSearchValue("");
            }
        }
    }

    // Opt-in grouping: with a groupBy prop the list renders a heading above the first option of each
    // group. The heading is drawn before the option row rather than inserted into the options array,
    // so selection, search and the load-more windowing keep working on the original indices.
    // Without the prop nothing is rendered and every other dropdown behaves exactly as before.
    const getGroupHeader = (option, index) => {
        if(!props.optionGroupKey || typeof option !== "object" || !option) return null;

        const groupValue = option[props.optionGroupKey];
        if(!groupValue) return null;

        const previous = index > 0 ? visibleOptions?.[index - 1] : null;
        if(previous && typeof previous === "object" && previous[props.optionGroupKey] === groupValue) return null;

        return (
            <Box
                sx={{
                    width:1,
                    px:1.5,
                    pt: index === 0 ? 0 : 1,
                    flexShrink:0,
                }}
            >
                <Text bold light noBreak>{props.useTranslation ? t(groupValue) : groupValue}</Text>
            </Box>
        );
    };

    const handleToggleSelectAll = () => {
        if(!multiple) return;
        const allFilteredValues = filteredOptions?.map((option) =>
            getOptionValue(option, props.options.indexOf(option))
        );

        const allSelected = allFilteredValues.every(val => props.selected?.includes(val));

        if(allSelected) {
            props.onChange([]);
        } else {
            const uniqueValues = [...new Set([...props.selected, ...allFilteredValues])];
            props.onChange(uniqueValues);
        }
    };

    const areAllFilteredSelected = useMemo(() => {
        if(!multiple || !filteredOptions?.length) return false;
        const allFilteredValues = filteredOptions?.map((option) =>
            getOptionValue(option, props.options.indexOf(option))
        );

        return allFilteredValues.every(val => props.selected?.includes(val));
    }, [filteredOptions, props.selected, multiple]);

    return (
        
        <PopoverModal
            // stopPropagation={props.modalPropagation ?? false}
            {...filteredProps}
            triangle={{position:"center",color:theme.palette.mode === "dark" ? colors.grey[300] : "#fff"}}
        >
            <Box 
                sx={{
                    background: theme.palette.mode === "dark" ? colors.grey[300] : "#fff",
                    padding:1.5,
                    paddingBottom: isStandAlone ? 1.5 : 1.5,
                    borderRadius:"16px",
                    borderBottomLeftRadius:0,
                    borderBottomRightRadius:0,
                    "@media screen and (max-width: 48em)" : {
                        borderRadius:"32px",
                        borderTopLeftRadius:"12px",
                        borderTopRightRadius:"12px",
                        borderBottomLeftRadius:0,
                        borderBottomRightRadius:0,

                    }
                }}
            >
                { props.searchOptions?.enabled &&
                    <Box
                        sx={{
                            mt:1.5,
                            mb:3,
                        }}
                    >
                        <TextInput
                            autoFocus
                            background={theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]}
                            value={searchValue}
                            onChange={handleSearchChange}
                            returnOnEnter={(e) => {
                                if(e.code === "Enter" && props.searchOptions.allowSelectionOnEnter){
                                    searchCompletion(e);
                                }
                            }}
                            placeholder={props.searchOptions.placeholder}
                        />
                    </Box>
                }
                <Box
                    ref={setScrollEl}
                    sx={{
                        minWidth: props.styles?.minWidth ?? null,
                        maxHeight:props.maxHeight || 300,
                        display:"flex",
                        gap:1,
                        flexDirection:"column",
                        overflowY:"auto",
                        alignItems:'center',
                        // maxHeight:250,
                    }}
                >
                    {(visibleOptions || [])?.map((option, index) => (
                        <React.Fragment key={"ddg" + index}>
                        {getGroupHeader(option, index)}
                        {props.shComponent ? (
                            <Box onClick={(event) => handleSelect(event, index)} key={"dd" + index} sx={{width:1}}>
                                {props.defaultStyling ? (
                                <Button
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        handleSelect(event, index);
                                    }}
                                    TouchRippleProps={{
                                    style: {
                                        color:
                                        theme.palette.mode === "dark"
                                            ? "rgba(255,255,255,.5)"
                                            : "rgba(49, 65, 95, 0.5)",
                                    },
                                    }}
                                    variant="contained"
                                    sx={{
                                    background: getBackground(index),
                                    color: getColor(index),
                                    width: 1,
                                    flexShrink: 0,
                                    borderRadius: "8px",
                                    padding: 0,
                                    minWidth: 150,
                                    paddingX: 1.5,
                                    display: "flex",
                                    alignItems: "center",
                                    overflow:"hidden",
                                    justifyContent: "flex-start",
                                    textTransform: "none",
                                    boxShadow: "none",
                                    "&:hover": {
                                        transition: "250ms",
                                        background:
                                        theme.palette.mode === "dark"
                                            ? colors.grey[400]
                                            : colors.bg["tertiary"],
                                        boxShadow: "none",
                                    },
                                    ...props.styles?.optionSx,
                                    }}
                                >
                                    {React.cloneElement(props.shComponent, {
                                    option,
                                    isSelected: isSelected(index),
                                    index,
                                    })}
                                </Button>
                                ) : (
                                <Box />
                                )}
                            </Box>
                        ) : (
                            <Button
                                key={"dd" + index}
                                onClick={(event) => handleSelect(event, index)}
                                TouchRippleProps={{
                                style: {
                                    color:
                                    theme.palette.mode === "dark"
                                        ? "rgba(255,255,255,.5)"
                                        : "rgba(49, 65, 95, 0.5)",
                                },
                                }}
                                variant="contained"
                                sx={{
                                background: getBackground(index),
                                color: getColor(index),
                                width: 1,
                                flexShrink: 0,
                                borderRadius: "8px",
                                padding: 0,
                                paddingX: 1.5,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                textTransform: "none",
                                minWidth: 150,
                                boxShadow: "none",
                                opacity: 1,
                                "&:hover": {
                                    transition: "250ms",
                                    background:
                                    theme.palette.mode === "dark"
                                        ? colors.grey[400]
                                        : colors.bg["tertiary"],
                                    boxShadow: "none",
                                },
                                }}
                            >
                                {typeof option === "object"
                                ? (props.useTranslation ? t(option[props.displayName]) : option[props.displayName])
                                : props.useTranslation
                                ? t(option)
                                : option}
                            </Button>
                        )}
                        </React.Fragment>
                    ))}
                    {/* The ref is attached to an empty div at the bottom to trigger load more */}
                    {displayCount < filteredOptions?.length && (
                        <div ref={ref} style={{ height: "10px", flexShrink: 0, width: "100%" }} />
                    )}
                    {/* {optionsList} */}
                    {filteredOptions?.length === 0 &&
                        <Box
                            sx={{
                                maxWidth:300,
                                display:"flex",
                                justifyContent:"center",
                                flexDirection:"column",
                                alignItems:"center",
                                mb:3,
                            }}
                        >
                            <TableEmpty/>
                            <Box
                                sx={{
                                    mt:3,
                                    display:"flex",
                                    flexDirection:"column",
                                    gap:0.5,
                                    textAlign:"center",
                                }}
                            >
                                <Subheading align="center" bold>{t('search_no_result_title')}</Subheading>
                                <Text align="center" light>{t('search_no_result_description')}</Text>
                            </Box>
                        </Box>
                    }
                </Box>

                {/* Select All / Deselect All Footer */}
                {multiple && filteredOptions?.length > 0 && props.allowSelectAll && (
                    <Box
                        sx={{
                            position: "sticky",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            background: theme.palette.mode === "dark" ? colors.grey[300] : "#fff",
                            borderTop: `1px solid ${theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[200]}`,
                            paddingTop: 1,
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <ButtonBase
                            onClick={handleToggleSelectAll}
                            className={cx({
                                'selected': areAllFilteredSelected,
                                'deselected': !areAllFilteredSelected
                            })}
                            sx={{
                                width: 1,
                                height:32,
                                borderRadius:4,
                                lineHeight:"32px",
                                textAlign:'center',
                                textTransform: "none",
                                transition: "all 250ms",
                                "&.selected": {
                                    background: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                                    color:theme.palette.mode === "dark" ? colors.txt['primaryDark'] : colors.txt['light'],
                                },
                                "&.deselected": {
                                    background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                    color: colors.txt.primary,
                                    "&:hover": {
                                        background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[200],
                                    },
                                },
                            }}
                        >
                            {areAllFilteredSelected ? t('deselect_all') : t('select_all')}
                        </ButtonBase>
                    </Box>
                )}
            </Box>

        </PopoverModal>
    );
}

export default ShDropdown;

export const ShDropdownQuery = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [anchorEl, setAnchorEl] = useState(null);

    const handlePopoverOpen = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };
  
    const handlePopoverClose = () => {
      setAnchorEl(null);
    };

    if (props.disallowDeselection && props.multiple) {
        throw Error("Disallowdeselection and multiple selection cannot go together");
    }
    const { t } = useTranslation();
    const multiple = props.multiple ?? false;
    const [searchValue, setSearchValue] = useState('');
    const [filteredOptions, setFilteredOptions] = useState([]);
    const workerRef = useRef(null);
    const debounceTimeoutRef = useRef(null);
    
    const [debouncedSearchValue, setDebouncedSearchValue] = useState(searchValue);

    const shouldSkip = props.lazyLoad ? !anchorEl : false;
    const {data,isLoading,isFetching,error,isError} = props.content ? props.content(props.config ?? null, { skip: shouldSkip }) : [];
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const getOptionValue = (option, index) => {
        if(typeof option === "undefined") return null;

        // If valueKey is provided and the option is an object, use it to get the value.
        // Otherwise, default to using the index as the value.
        return props.valueKey && typeof option === "object" ? option?.[props.valueKey] : data?.indexOf(option);
    };

    const switchSelected = (index) => {
        const selectedValue = getOptionValue(filteredOptions[index], index);
        const isValueSelected = props.valueKey ? selectedValue === props.selected : index === props.selected;

        if(props.searchOptions?.enabled) {
            
            setSearchValue("");
            filterOptions("");
        }

        if(!multiple) {
            if(isValueSelected && !props.disallowDeselection) {
                props.onChange(props.valueKey ? null : -1);
            } else {
                props.onChange(selectedValue,filteredOptions[index]);
            }
        } else {
            if (props.selected.includes(selectedValue)) {
                const newSelected = props.selected.filter(val => val !== selectedValue);
                props.onChange(newSelected,filteredOptions[index]);
            } else {
                const newSelected = [...props.selected, selectedValue];
                props.onChange(newSelected,filteredOptions[index]);
            }
        }

        if(props.closeOnSelection) {
            setAnchorEl(null);
        }
    };

    const isSelected = (index) => {
        const selectedValue = getOptionValue(filteredOptions[index], index);
        const currentValue = typeof props.selected === 'number' ? props.selected : getOptionValue(props.selected);

        if(!multiple) {
            return selectedValue === currentValue;
        }
        
        return props.selected?.includes(selectedValue);
    };

    const getBackground = (index) => {
        if(isSelected(index)) {
            return theme.palette.mode === "dark" ?
                colors.blue[100] : colors.primary[100];
        }
        return theme.palette.mode === "dark" ? colors.grey[300] : "#fff";
    }
    const getColor = (index) => {
        if(isSelected(index)) {
            return theme.palette.mode === "dark" ?
                colors.blue[400] : colors.primary[400];
        }
        return colors.txt.primary;
    }

    const handleEnter = (event) => {
        if(event.code === "Enter") {
            const value = event.target.value;
            if (!value) {

                if(props.dataKey){
                    setFilteredOptions(getNestedValue(data,props.dataKey));
                } else {
                    setFilteredOptions(data);
                }
                return;
            }

            // Only continue if exactly 1 match in filteredOptions
            if (filteredOptions?.length === 1) {
                switchSelected(0);
            }
        }
    }

    // Handle search input change with debounce
    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchValue(value);

        // Clear previous debounce timeout
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        // Set a new debounce timeout
        debounceTimeoutRef.current = setTimeout(() => {
            filterOptions(value); // Apply filtering after debounce delay
        }, 300); // 300ms debounce delay (adjust as needed)
    };

    // Filter options based on search value
    const filterOptions = (value) => {

        if (!value) {

            if(props.dataKey){
                setFilteredOptions(getNestedValue(data,props.dataKey));
            } else {
                setFilteredOptions(data);
            }
            return;
        }

        const lowerCasedSearchValue = value.toLowerCase();
        const source = props.dataKey ? data?.[props.dataKey] : data;

        const filtered = source?.filter(option => {
            // Use the dynamic property name from props.displayName to access the right field
            const optionValue = option && option[props.displayName] ? option[props.displayName] : option;
            
            if (optionValue && optionValue.toString) {
                return optionValue.toString().toLowerCase().includes(lowerCasedSearchValue);
            }

            // Skip undefined or null values
            return false;
        });

        setFilteredOptions(filtered);
    };

    const getNestedValue = (obj, path) => {
        return path.split('.').reduce((acc, part) => {
          if (acc && acc[part] !== undefined) {
            return acc[part];
          }
          return undefined; // return undefined if path doesn't exist
        }, obj);
      }

    // Reset filtered options when props.options changes
    useEffect(() => {
        if(data){
            if(props.dataKey){
                setFilteredOptions(getNestedValue(data,props.dataKey));
            } else {
                setFilteredOptions(data);
            }
        }
    }, [data, props.dataKey, props.open]);

    const handleToggleSelectAll = () => {
        if(!multiple) return;
        const allFilteredValues = filteredOptions?.map((option, index) =>
            getOptionValue(option, index)
        );

        const allSelected = allFilteredValues.every(val => props.selected?.includes(val));

        if(allSelected) {
            props.onChange([]);
        } else {
            const uniqueValues = [...new Set([...props.selected, ...allFilteredValues])];
            props.onChange(uniqueValues);
        }
    };

    const areAllFilteredSelected = useMemo(() => {
        if(!multiple || !filteredOptions?.length) return false;
        const allFilteredValues = filteredOptions?.map((option, index) =>
            getOptionValue(option, index)
        );

        return allFilteredValues.every(val => props.selected?.includes(val));
    }, [filteredOptions, props.selected, multiple]);

    const handleSelect = useCallback((event,index) => {
        if(props.unSelectable) return;
        switchSelected(index);
    }, [switchSelected, props.unSelectable]); // Include any dependencies if necessary

    return (
        <>
            {props.children({
                anchorEl,
                onClick: handlePopoverOpen,
            })}
            {((typeof props.open === "undefined" || props.open === null) || (props.open)) &&
                <PopoverModal
                    sx={props.modalsx ?? null}
                    id="simple-popover"
                    open={Boolean(anchorEl)}
                    {...props}
                    anchorEl={anchorEl}
                    onClose={handlePopoverClose}
                    triangle={{position:props.position ?? "center",color:theme.palette.mode === "dark" ? colors.grey[300] : "#fff"}}
                >

                    <Box
                        sx={{
                            maxHeight:320,
                            overflow:"auto",
                            maxWidth:props.maxWidth ?? 450,
                            background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                            px:1.5,
                            py:1.5,
                            pb:(multiple && filteredOptions?.length > 0 && props.allowSelectAll) ? 0 : null,
                            display:'flex',
                            flexDirection:"column",
                            gap:1,
                            "@media screen and (max-width:47.9375em)" : {
                                maxWidth:"unset"
                            }
                        }}
                    >
                        { props.searchOptions?.enabled &&
                            <Box
                                sx={{
                                    mt:1.5,
                                    mb:1.5,
                                }}
                            >
                                <TextInput
                                    autoFocus={true}
                                    background={theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]}
                                    value={searchValue}
                                    onChange={handleSearchChange}
                                    returnOnEnter={(e) => {
                                        if(e.code === "Enter" && props.searchOptions.allowSelectionOnEnter){
                                            handleEnter(e);
                                        }
                                    }}
                                    placeholder={props.searchOptions.placeholder}
                                />
                            </Box>
                        }
                
                        {!isFetching && !isLoading ?
                            <>
                                {filteredOptions?.map((option, index) => (
                                    React.cloneElement(props.shComponent, {
                                        key:"filted"+index,
                                        option,
                                        onClick: (event) => handleSelect(event,index),
                                        isSelected: isSelected(index),
                                        index,
                                    })
                                ))}
                                 {filteredOptions?.length === 0 &&
                                    <Box
                                        sx={{
                                            maxWidth:300,
                                            display:"flex",
                                            justifyContent:"center",
                                            flexDirection:"column",
                                            alignItems:"center",
                                            mb:3,
                                        }}
                                    >
                                        <TableEmpty/>
                                        <Box
                                            sx={{
                                                mt:3,
                                                display:"flex",
                                                flexDirection:"column",
                                                gap:0.5,
                                                textAlign:"center",
                                            }}
                                        >
                                            <Subheading align="center" bold>{t('search_no_result_title')}</Subheading>
                                            <Text align="center" light>{t('search_no_result_description')}</Text>
                                        </Box>
                                    </Box>
                                }
                            </>
                        :
                            <Box>
                                Loading
                            </Box>
                        }

                        {/* Select All / Deselect All Footer */}
                        {multiple && filteredOptions?.length > 0 && props.allowSelectAll && (
                            <Box
                                sx={{
                                    position: "sticky",
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    pb:1,
                                    background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                                    borderTop: `1px solid ${theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]}`,
                                    paddingTop: 1,
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <ButtonBase
                                    onClick={handleToggleSelectAll}
                                    className={cx({
                                        'selected': areAllFilteredSelected,
                                        'deselected': !areAllFilteredSelected
                                    })}
                                    sx={{
                                        width: 1,
                                        height:32,
                                        borderRadius:4,
                                        lineHeight:"32px",
                                        textAlign:'center',
                                        textTransform: "none",
                                        transition: "all 250ms",
                                        "&.selected": {
                                            background: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                                            color:theme.palette.mode === "dark" ? colors.txt['primaryDark'] : colors.txt['light'],
                                        },
                                        "&.deselected": {
                                            background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                            color: colors.txt.primary,
                                            "&:hover": {
                                                background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[200],
                                            },
                                        },
                                    }}
                                >
                                    {areAllFilteredSelected ? t('deselect_all') : t('select_all')}
                                </ButtonBase>
                            </Box>
                        )}
                    </Box>
                </PopoverModal>
            }
        </>
    )
}

export const ShDropdownSearchQuery = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [anchorEl, setAnchorEl] = useState(null);

    const handlePopoverOpen = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };
  
    const handlePopoverClose = () => {
      setAnchorEl(null);
    };

    if (props.disallowDeselection && props.multiple) {
        throw Error("Disallowdeselection and multiple selection cannot go together");
    }
    const { t } = useTranslation();
    const multiple = props.multiple ?? false;
    const [searchValue, setSearchValue] = useState('');
    // const [filteredOptions, setFilteredOptions] = useState('');
    const debounceTimeoutRef = useRef(null);
    const [filteredOptions, setFilteredOptions] = useState([]);
    
    const [debouncedSearchValue, setDebouncedSearchValue] = useState(null);
    
    const {data,isLoading,isFetching,isError} = props.content({
        searchString:debouncedSearchValue,
        ...(props.config ?? {})
    }, {
        skip: !debouncedSearchValue || debouncedSearchValue.length < 3
    });


    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }


    const switchSelected = (id,option) => {
        if(props.unSelectable) return;
        const selectedValue = id;

        if(!multiple) {
            if(selectedValue === props.selected && !props.disallowDeselection) {
                props.onChange(-1);
            } else {
                props.onChange(selectedValue,option);
            }
        } else {
            if (props.selected.includes(selectedValue)) {
                const newSelected = props.selected.filter(val => val !== selectedValue);
                props.onChange(newSelected,option);
            } else {
                const newSelected = [...props.selected, selectedValue];
                props.onChange(newSelected,option);
            }
        }

        if(props.closeOnSelection) {
            setAnchorEl(null);
        }
    };

    const isSelected = (id) => {
        if(!multiple) {
            return id === props.selected;
        }
        return props.selected?.includes(id);
    };

    const getBackground = (index) => {
        if(isSelected(index)) {
            return theme.palette.mode === "dark" ?
                colors.blue[100] : colors.primary[100];
        }
        return theme.palette.mode === "dark" ? colors.grey[300] : "#fff";
    }
    const getColor = (index) => {
        if(isSelected(index)) {
            return theme.palette.mode === "dark" ?
                colors.blue[400] : colors.primary[400];
        }
        return colors.txt.primary;
    }

    // Handle search input change with debounce
    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchValue(value);

        // Clear previous debounce timeout
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        // Set a new debounce timeout
        debounceTimeoutRef.current = setTimeout(() => {
            setDebouncedSearchValue(value);
            // filterOptions(value); // Apply filtering after debounce delay
        }, 300); // 300ms debounce delay (adjust as needed)
    };

    const getNestedValue = (obj, path) => {
        return path.split('.').reduce((acc, part) => {
            if (acc && acc[part] !== undefined) {
                return acc[part];
            }
            return undefined; // return undefined if path doesn't exist
        }, obj);
    }

    // Reset filtered options when props.options changes
    useEffect(() => {
        if(data){
            if(props.dataKey){
                setFilteredOptions(getNestedValue(data,props.dataKey));
            } else {
                setFilteredOptions(data);
            }
        }
    }, [data, props.dataKey, props.open]);

    // const handleSelect = useCallback((event,id) => {
    //     switchSelected(id);
    // }, [switchSelected]); // Include any dependencies if necessary
    return (
        <>
            {props.children({
                anchorEl,
                onClick: handlePopoverOpen,
            })}
            {((typeof props.open === "undefined" || props.open === null) || (props.open)) &&
                <PopoverModal
                    sx={props.modalsx ?? null}
                    id="simple-popover"
                    open={Boolean(anchorEl)}
                    {...props}
                    anchorEl={anchorEl}
                    onClose={handlePopoverClose}
                    triangle={{position:props.position ?? "center",color:theme.palette.mode === "dark" ? colors.grey[300] : "#fff"}}
                >
                    <Box
                        sx={{
                            background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                            pb:1.5,
                        }}
                    >
                        <Box
                            sx={{
                                pt:1.5,
                                mb:1.5,
                                mx:1.5,
                            }}
                        >
                            <TextInput
                                autoFocus
                                background={theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]}
                                value={searchValue}
                                onChange={handleSearchChange}
                                placeholder={props.searchOptions?.placeholder}
                            />
                        </Box>
                        <Box
                            sx={{
                                maxHeight:props.maxHeight || 320,
                                overflow:"auto",
                                maxWidth:props.maxWidth ?? 450,
                                px:1.5,
                                pt:1.5,
                                display:'flex',
                                flexDirection:"column",
                                gap:1,
                                "@media screen and (max-width:47.9375em)" : {
                                    maxWidth:"unset"
                                }
                            }}
                        >
                
                            {(!isFetching && !isLoading && filteredOptions.length !== 0) &&
                                <>
                                    {filteredOptions?.map((option, index) => (
                                        props.shComponent ? (
                                            <Box
                                                key={"dd"+index}
                                                onClick={(event) => switchSelected(option.id,option)}
                                                sx={{width:1, flexShrink:0}}
                                            >
                                                {React.cloneElement(props.shComponent, {
                                                    option,
                                                    isSelected: isSelected(option.id),
                                                    index,
                                                })}
                                            </Box>
                                        ) : (
                                        <Button
                                            key={"dd"+index}
                                            onClick={(event) => switchSelected(option.id,option)}
                                            TouchRippleProps={{
                                                style: {
                                                    color: theme.palette.mode === "dark" ? "rgba(255,255,255,.5)" : 'rgba(49, 65, 95, 0.5)'
                                                }
                                            }} // Directly styling the ripple here
                                            variant='contained'
                                            sx={{
                                                background:getBackground(option.id),
                                                color: getColor(option.id),
                                                width:1,
                                                // height:32,
                                                flexShrink:0,
                                                borderRadius:"8px",
                                                padding:0,
                                                minWidth:0,
                                                paddingX:1.5,
                                                display: "flex",
                                                alignItems:"center",
                                                justifyContent:"flex-start",
                                                textAlign:"left",
                                                textTransform:"none",
                                                minWidth:150,
                                                boxShadow: "none",
                                                opacity:1,
                                                "&:hover" : {
                                                    transition:"250ms",
                                                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.bg["tertiary"],
                                                    boxShadow:"none"
                                                },
                                            }}
                                        >
                                            {typeof option === "object" ? option[props.displayName] : props.useTranslation ? t(option) : option}

                                        </Button>
                                        )
                                    ))}
                                    {filteredOptions?.length === 0 &&
                                        <Box
                                            sx={{
                                                maxWidth:300,
                                                display:"flex",
                                                justifyContent:"center",
                                                flexDirection:"column",
                                                alignItems:"center",
                                                mb:3,
                                            }}
                                        >
                                            <TableEmpty/>
                                            <Box
                                                sx={{
                                                    mt:3,
                                                    display:"flex",
                                                    flexDirection:"column",
                                                    gap:0.5,
                                                    textAlign:"center",
                                                }}
                                            >
                                                <Subheading align="center" bold>{t('search_no_result_title')}</Subheading>
                                                <Text align="center" light>{t('search_no_result_description')}</Text>
                                            </Box>
                                        </Box>
                                    }
                                </>
                            
                            }
                            {(filteredOptions.length === 0 && (!debouncedSearchValue  || debouncedSearchValue.length < 3)) &&
                                <Box
                                    sx={{
                                        maxWidth:300,
                                        display:"flex",
                                        justifyContent:"center",
                                        flexDirection:"column",
                                        alignItems:"center",
                                        mb:3,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            mt:3,
                                            display:"flex",
                                            flexDirection:"column",
                                            gap:0.5,
                                            textAlign:"center",
                                        }}
                                    >
                                        <Subheading align="center" bold>{t('search_query_too_short_title')}</Subheading>
                                        <Text align="center" light>{t('search_query_too_short_subtitle')}</Text>
                                    </Box>
                                </Box>
                            }
                             {filteredOptions?.length === 0 &&
                                    <Box
                                        sx={{
                                            maxWidth:300,
                                            display:"flex",
                                            justifyContent:"center",
                                            flexDirection:"column",
                                            alignItems:"center",
                                            mb:3,
                                        }}
                                    >
                                        <TableEmpty/>
                                        <Box
                                            sx={{
                                                mt:3,
                                                display:"flex",
                                                flexDirection:"column",
                                                gap:0.5,
                                                textAlign:"center",
                                            }}
                                        >
                                            <Subheading align="center" bold>{t('search_no_result_title')}</Subheading>
                                            <Text align="center" light>{t('search_no_result_description')}</Text>
                                        </Box>
                                    </Box>
                                }
                        </Box>
                        {props.extraComponent && props.extraComponent}
                    </Box>
                </PopoverModal>
            }
        </>
    )
}